/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

export const kLastHour = 'lasthour';
export const kLastDay = 'lastday';
export const kLastMonth = 'lastmon';
export const kTimeRanges = [
  kLastHour,
  kLastDay,
  kLastMonth,
];

export const kGroupByTime = 'time';
export const kGroupByTypes = [
  kGroupByTime,
];

export const kGroupOneMin = 'onemin';
export const kGroupTenMin = 'tenmin';
export const kGroupOneHour = 'onehour';
export const kGroupTimes = [
  kGroupOneMin,
  kGroupTenMin,
  kGroupOneHour,
];

export const kDeviceFilter = 'device';
export const kFilterTypes = [
  kDeviceFilter,
];

export const kGroupFuncMin = 'min';
export const kGroupFuncMax = 'max';
export const kGroupFuncAvg = 'avg';
export const kGroupFuncSum = 'sum';
export const kGroupFuncTypes = [
  kGroupFuncMin,
  kGroupFuncMax,
  kGroupFuncAvg,
  kGroupFuncSum,
];

export const kSeriesDevice = 'device';
export const kSeriesTypes = [
  kSeriesDevice,
];




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/constants.js